const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "REMARK_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "REMARK_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "REMARK_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    case "REMARK_RESET":
      return initialState;
    default:
      return state;
  }
};
